import { 
  createSliceLayout,
  SliceEntityItemsWithFilters,
  SliceEntityItemsWithFiltersProps,
  SliceSpacer,
  SliceSpacerProps,
} from '@shapeable/ui';

// Augment standard site layouts here by exporting additional or replacement layouts.
// (simply use the same key to replace any existing slice layouts).

export const SliceLayoutSpacer16 = createSliceLayout<SliceSpacerProps>(
  SliceSpacer, {
    props: { units: 16 / 4 },
  }
);

export const SliceLayoutEntityItemsWithFilters = createSliceLayout<SliceEntityItemsWithFiltersProps>(
  SliceEntityItemsWithFilters, {
    boundary: 'explorer',
    verticalPadding: 'none',
    props: {
      showSearchBar: true,
    }
  }
);